import React from "react";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import api, { toErrMsg } from "@/lib/api";
import { toast } from "sonner";

/**
 * T1 round 4 — one-liner Download Template button. Fetches
 * `/api/templates/{kind}` (styled .xlsx with EN row 1 + AR row 2,
 * required columns `*`-marked, example row) and triggers the browser
 * download. Used on every upload dialog with a known template kind.
 *
 * Round 6 · Z0 — route through the shared axios ``api`` instance so
 * the request carries the real session token (``af_token`` in
 * localStorage, injected by ``api.interceptors.request`` in
 * ``lib/api.js``) and participates in the 401 / step-up / 404
 * interceptors like every other authenticated call. Previously this
 * component read ``localStorage.getItem("token")`` (wrong key) and
 * used raw ``fetch``, which produced HTTP 401 for every logged-in
 * owner.
 */
export default function DownloadTemplateButton({ kind, size = "sm",
                                                     testid, label }) {
  const { t } = useI18n();
  const click = async () => {
    try {
      const r = await api.get(`/templates/${encodeURIComponent(kind)}`,
                                { responseType: "blob", _silent: true });
      const blob = r.data;
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `${kind}_template.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(a.href);
    } catch (e) {
      toast.error(toErrMsg(e, "Download failed"));
    }
  };
  return (
    <Button type="button" variant="outline" size={size}
            onClick={click}
            data-testid={testid || `download-template-${kind}`}>
      <Download className="me-1 h-3 w-3" />
      {label || t("headFolders.downloadTemplate") || "Download template"}
    </Button>
  );
}
